export default {
  common: {
    close: 'Close',
    cancel: 'Cancel',
    login: 'Login',
    register: 'Register',
    logout: 'Logout',
    langZh: '中文',
    langEn: 'English',
    userFallback: 'User'
  },
  homepage: {
    flowTagline: 'Resume, reimagined.',
    flowTitle: 'AI Resume & Career Assistant',
    flowSubtitle: 'Get job recommendations that match your resume, or personalized skill improvement advice. AI-powered matching and guidance.',
    ctaJobRecommendations: 'Job Recommendations',
    ctaJobRecommendationsDesc: 'Find roles that match your resume. AI-powered matching and explanations.',
    ctaSkillAdvice: 'Skill Improvement Advice',
    ctaSkillAdviceDesc: 'Get personalized skill improvement advice based on your resume.',
    ctaInterviewDebrief: 'Interview Debrief',
    ctaInterviewDebriefDesc: 'Document and learn from your interviews. Get a summary and actionable learnings.',
    howItWorksTitle: 'How it works',
    howItWorksStep1: 'Upload or paste your resume',
    howItWorksStep2: 'Ask for job recommendations or skill advice',
    howItWorksStep3: 'Get AI-powered matching and personalized guidance',
    benefitsTitle: 'Benefits',
    benefitUploadNoLogin: 'Upload resume without login',
    benefitJobExplanations: 'Job recommendations with explanations',
    benefitSkillAdvice: 'Personalized skill improvement advice',
    benefitAIGuidance: 'AI-powered matching and guidance',
    legacyEditor: 'Switch to Legacy Editor'
  },
  app: {
    title: 'Agentic Career Assistant',
    headerLogo: 'Agentic Career Assistant',
    subtitle: 'Upload your resume and transform it with humor',
    navJobRecommendations: 'Job Recommendations',
    navInterviewDebrief: 'Interview Debrief',
    resumeLibrary: 'Resume Library',
    inviteFriends: 'Invite Friends',
    welcome: 'Welcome, {name}',
    footerCopy: "AI Resume & Career Assistant © {year} {'|'} Powered by DeepSeek",
    footerCopyPrefix: "AI Resume & Career Assistant © {year} {'|'} Powered by ",
    footerCopySuffix: '',
    announcementText: 'New: Job Recommendations — find roles that match your resume.',
    announcementLinkLabel: 'Try it',
    footerProduct: 'Product',
    footerSkillAdvice: 'Skill Improvement Advice',
    footerLegalSafety: 'Legal & Safety',
    termsNoticePrefix: 'By using AI Resume Editor, you agree to ',
    termsNoticeSuffix: ' and have read ',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    policeAlt: 'Police filing'
  },
  resumeLibrary: {
    back: '← Back',
    title: 'Resume Library',
    subtitle: 'Store and manage your resumes. Download anytime for interviews.',
    quota: '{count}/5 resumes',
    uploadNew: 'Upload new resume',
    uploading: 'Uploading…',
    uploadHint: 'PDF only, max 10MB',
    emptyState: 'No resumes yet. Upload your first resume to get started.',
    pages: 'pages',
    download: 'Download',
    downloading: 'Downloading…',
    replace: 'Replace',
    replacing: 'Replacing…',
    delete: 'Delete',
    deleting: 'Deleting…',
    replaceTitle: 'Replace resume',
    replaceHint: 'Choose a new PDF to replace the current one.',
    chooseFile: 'Choose file'
  },
  jobRecommendations: {
    back: '← Back',
    title: 'Job Recommendations',
    subtitle: 'Ask for job recommendations based on your resume',
    emptyPrompt: 'Ask for job recommendations based on your resume.',
    greeting: "Hello, I'm your career assistant",
    newChat: 'New chat',
    closeSidebar: 'Close sidebar',
    openSidebar: 'Open sidebar',
    modeJobRecommendations: 'Job Recommendations',
    modeSkillAdvice: 'Skill Advice',
    inputPlaceholderSlash: 'Type message or press / to switch mode…',
    suggestedPrompt: 'Recommend jobs for me',
    suggestedPromptSkillAdvice: 'What skills should I improve?',
    suggestedPrompt1: 'Recommend jobs for me',
    suggestedPrompt2: 'What skills should I improve?',
    suggestedPrompt3: 'Find roles that match my experience',
    suggestedPrompt4: 'Suggest adjacent careers',
    suggestedPrompt5: 'Help me prepare for interviews',
    suggestedPrompt6: 'Compare my resume to a job description',
    viewJob: 'View job →',
    parsingPdf: 'Parsing PDF…',
    findingJobs: 'Finding jobs…',
    loadingSkillAdvice: 'Analyzing skills…',
    loadingInterviewDebrief: 'Processing notes…',
    loadingDefault: 'Processing…',
    tryAgain: 'Try again',
    provideResume: 'Provide your resume:',
    uploadPdf: 'Upload resume (PDF)',
    attachResume: 'Attach resume (PDF)',
    pasteText: 'Paste resume text',
    pastePlaceholder: 'Paste your resume text here…',
    usePaste: 'Use this resume',
    resumeAttached: 'Resume attached',
    usingSavedResume: 'Using your saved resume',
    inputPlaceholder: 'Ask for job recommendations…',
    send: 'Send',
    showReasoning: 'Show reasoning',
    hideReasoning: 'Hide reasoning',
    noReasoning: 'No reasoning available for this step.',
    humorousResumeTitle: 'Humorous Resume',
    copyHumorousResume: 'Copy',
    openInEditor: 'Open in Editor',
    showHumorousResume: 'Show humorous resume',
    copiedToClipboard: 'Copied to clipboard',
    bestMatches: 'Best matches',
    relatedRoles: 'Related roles',
    stretchOpportunities: 'Stretch opportunities',
    youMightAlsoConsider: 'You might also consider',
    whyThisJob: 'Why this job?',
    explainLoading: 'Loading…',
    explainError: "Couldn't load explanation. Try again.",
    explainNeedResume: 'Provide a resume first to see why this job fits.',
    titleInterviewDebrief: 'Interview Debrief',
    subtitleInterviewDebrief: 'Document, summarize, and learn from your recent interviews.',
    emptyPromptInterviewDebrief: 'Share what happened in your interview and get a summary plus actionable learnings.',
    suggestedPromptInterviewDebrief: 'I want to debrief my recent interview',
    inputPlaceholderInterviewDebrief: 'Share your interview notes or ask to see past debriefs…',
    agentStep: {
      thinking: 'Thinking…',
      ask_user_start: 'Asking for info',
      ask_user_done: 'Asked for info',
      capture_preferences_start: 'Saving preferences',
      capture_preferences_done: 'Saved preferences',
      load_profile_start: 'Loading profile',
      load_profile_done: 'Profile loaded',
      parse_resume_start: 'Parsing resume',
      parse_resume_done: 'Parsed resume',
      search_jobs_start: 'Searching jobs…',
      search_jobs_done: 'Searched {n} jobs',
      search_jobs_multi_start: 'Searching jobs…',
      search_jobs_multi_done: 'Searched {n} jobs',
      rank_and_filter_jobs_start: 'Ranking jobs…',
      rank_and_filter_jobs_done: 'Ranked {n} jobs',
      attempt_completion_start: 'Preparing results…',
      attempt_completion_done: 'Done',
      use_skill_start: 'Loading skill…',
      use_skill_done: 'Skill loaded'
    },
    exportToNotion: 'Export to Notion',
    voice: {
      playAudio: 'Read aloud',
      stopAudio: 'Stop reading',
      loadingAudio: 'Loading audio...',
      audioError: 'Audio playback failed',
      voiceInput: 'Voice input',
      voiceInputListening: 'Listening...',
      voiceInputStop: 'Stop listening',
      voiceNotEnabled: 'Voice features are not available',
      conversationMode: 'Voice conversation',
      conversationModeStop: 'End voice conversation',
      stateListening: 'Listening...',
      stateProcessing: 'Thinking...',
      stateSpeaking: 'Speaking...',
      interrupt: 'Interrupt'
    }
  },
  auth: {
    login: 'Login',
    register: 'Register',
    close: 'Close',
    dontHaveAccount: "Don't have an account?",
    registerHere: 'Register here',
    alreadyHaveAccount: 'Already have an account?',
    verificationNotice: "📧 You'll receive a verification email after registration.",
    username: 'Username',
    usernamePlaceholder: 'Choose a username',
    email: 'Email',
    // Literal {'@'} so vue-i18n message format does not parse @ as linked message
    emailPlaceholder: "your{'@'}email.com",
    firstName: 'First Name',
    firstNamePlaceholder: 'First name',
    lastName: 'Last Name',
    lastNamePlaceholder: 'Last name',
    password: 'Password',
    passwordPlaceholderLogin: 'Enter your password',
    passwordPlaceholderRegister: 'Create a password',
    showPassword: 'Show password',
    hidePassword: 'Hide password',
    confirmPassword: 'Confirm Password',
    confirmPasswordPlaceholder: 'Confirm your password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    processing: 'Processing...',
    needVerifyEmail: 'Need to verify your email?',
    clickHere: 'Click here',
    resetPassword: 'Reset Password',
    resetPasswordIntro: "Enter your email address and we'll send you a link to reset your password.",
    sendResetLink: 'Send Reset Link',
    sending: 'Sending...',
    cancel: 'Cancel',
    wechatLogin: 'WeChat Login',
    wechatScanPrompt: 'Scan this QR code with WeChat to login',
    wechatQRAlt: 'WeChat QR Code',
    generatingQR: 'Generating QR code...',
    continueWithGoogle: 'Continue with Google',
    or: 'or',
    scanQRWithWeChat: 'Scan QR code with WeChat',
    qrScannedConfirm: 'QR code scanned. Please confirm on your device.',
    passwordRequirement: 'Must be at least 8 characters with uppercase, lowercase, number, and special character',
    rule: {
      minLength: 'At least 8 characters',
      uppercase: 'One uppercase letter',
      lowercase: 'One lowercase letter',
      number: 'One number',
      specialChar: "One special character (!{'@'}#$%...)"
    },
    passwordStrength: {
      weak: 'Weak',
      medium: 'Medium',
      good: 'Good',
      strong: 'Strong'
    }
  },
  credits: {
    credits: 'credits',
    lowBalanceWarning: 'Low balance warning',
    history: 'History',
    viewCreditHistory: 'View credit history',
    insufficientTitle: 'Insufficient Credits',
    youNeed: 'You need',
    creditsToUse: 'credits to use this service.',
    yourBalance: 'Your current balance:',
    youNeedMore: 'You need',
    moreCredits: 'more credits.',
    service: 'Service:',
    inviteToEarn: 'Invite friends to earn credits and continue using this service.',
    inviteFriendsToEarn: 'Invite Friends to Earn Credits',
    gotIt: 'Got it',
    creditHistory: 'Credit History',
    loadingHistory: 'Loading transaction history...',
    retry: 'Retry',
    noTransactionHistory: 'No transaction history found',
    transaction: 'Transaction',
    previous: 'Previous',
    next: 'Next',
    showing: 'Showing',
    of: 'of'
  },
  invitation: {
    sendInvitation: 'Send Invitation',
    emailAddress: 'Email Address',
    nameOptional: 'Name (Optional)',
    friendNamePlaceholder: "Friend's name",
    personalMessageOptional: 'Personal Message (Optional)',
    personalMessagePlaceholder: 'Add a personal message...',
    cancel: 'Cancel',
    sendInvitationBtn: 'Send Invitation',
    sending: 'Sending...'
  },
  legal: {
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    loadingDocument: 'Loading document...',
    failedToLoad: 'Failed to load document',
    failedToLoadRetry: 'Failed to load document. Please try again.',
    close: 'Close'
  },
  resetPassword: {
    validatingToken: 'Validating Reset Token',
    pleaseWaitValidate: 'Please wait while we validate your password reset link...',
    invalidOrExpiredLink: 'Invalid or Expired Link',
    invalidLinkMessage: 'This password reset link is invalid or has expired. Password reset links expire after 24 hours.',
    requestNewResetLink: 'Request New Reset Link',
    goToLogin: 'Go to Login',
    resetYourPassword: 'Reset Your Password',
    enterNewPasswordBelow: 'Enter your new password below',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    passwordRequirement: 'Must be at least 8 characters with uppercase, lowercase, number, and special character',
    resettingPassword: 'Resetting Password...',
    resetPasswordBtn: 'Reset Password',
    cancel: 'Cancel',
    successTitle: 'Password Reset Successful!',
    successMessage: 'Your password has been reset successfully. You can now login with your new password.',
    loginWithNewPassword: 'Login with New Password'
  },
  editor: {
    generatingPdf: 'Generating PDF',
    aiHumorousResumeGenerator: 'AI Humorous Resume Generator',
    resumeReimagined: 'Resume, reimagined.',
    flowSubtitle: 'Upload your resume PDF and get a humorous version in one click. Or discover jobs that match your profile.',
    ctaDescFree: 'Free to try. Upload PDF → AI transforms to humorous style → Download.',
    ctaJobDesc: 'Find roles that match your resume. AI-powered matching and explanations.',
    switchToLegacyEditor: 'Switch to Legacy Editor',
    resumeEditor: 'Resume Editor',
    tryNewFlow: 'Try New Flow',
    exportPdf: 'Export PDF',
    newResume: 'New Resume',
    resumeContent: 'Resume Content',
    chooseDifferentFile: 'Choose Different File',
    tipsForBestResults: 'Tips for best results:',
    tipCleanPdf: 'Use a clean, text-based PDF (not scanned images)',
    tipSelectable: 'Ensure text is selectable in your PDF',
    tipMaxSize: 'Maximum file size: 10MB',
    tipOcr: 'For scanned resumes, use OCR software first',
    processingPdf: 'Processing PDF',
    transformingToHumorous: 'Transforming to Humorous',
    startingPipeline: 'Starting pipeline...',
    startingPdfProcessing: 'Starting PDF processing...',
    transformationComplete: 'Transformation complete, generating PDF...',
    pipelineCompleted: 'Pipeline completed successfully!',
    resumeBeingGenerated: 'Your humorous resume is being generated...',
    resumeReadyToDownload: 'Your humorous resume is ready to download!',
    howItWorks: 'How it works',
    uploadStep: 'Upload your resume PDF',
    processStep: 'Process with AI to extract text',
    transformStep: 'Transform to humorous style',
    generateStep: 'Generate and download PDF',
    benefits: 'Benefits',
    benefitUploadNoLogin: 'Upload resume without login',
    benefitLoginRequired: 'Login required for generation',
    benefitAutomated: 'Fully automated pipeline',
    benefitAIPowered: 'AI-powered humor transformation',
    benefitProfessionalPdf: 'Professional PDF formatting',
    uploadResumePdf: 'Upload Resume PDF',
    dragAndDropOrClick: 'Drag and drop or click to browse',
    supportsPdf10mb: 'Supports PDF files up to 10MB',
    changeFile: 'Change File',
    humorIntensity: 'Humor Intensity:',
    subtle: 'Subtle',
    medium: 'Medium',
    overt: 'Overt',
    preserveKeyInfo: 'Preserve Key Information',
    useAILayoutEnhancement: 'Use AI Layout Enhancement',
    aiServiceNotAvailable: '(AI service not available)',
    startGeneration: 'Start Generation',
    processing: 'Processing...',
    uploadYourResumePdf: 'Upload Your Resume PDF',
    dragDropOrClick: 'Drag and drop your PDF file here, or click to browse',
    removeFile: 'Remove file',
    processResume: 'Process Resume',
    switchToPreview: 'Switch to preview',
    switchToEdit: 'Switch to edit',
    previewBtn: 'Preview',
    editBtn: 'Edit',
    bold: 'Bold',
    italic: 'Italic',
    heading: 'Heading',
    bulletList: 'Bullet list',
    words: 'words',
    addComment: 'Add Comment',
    startEditingPlaceholder: 'Start editing your resume here...',
    selected: 'Selected:',
    clearSelection: 'Clear selection',
    aiAnalyzing: 'AI is analyzing your resume...',
    noSuggestionsYet: 'No suggestions yet',
    selectTextAndGetAI: 'Select text in your resume and click "Get AI Suggestions" to get started.',
    tryAskingAI: 'Try asking AI to:',
    makeMoreConcise: 'Make this more concise',
    strongerActionVerbs: 'Use stronger action verbs',
    improveGrammar: 'Improve grammar and clarity',
    addMetrics: 'Add metrics and quantifiable results',
    aiSuggestions: 'AI Suggestions',
    copySuggestions: 'Copy suggestions',
    applyAllSuggestions: 'Apply All Suggestions',
    requestCustomEdit: 'Request Custom Edit',
    tellAIWhatToChange: 'Tell AI exactly what you want to change...',
    submitToAI: 'Submit to AI',
    cancel: 'Cancel',
    commentsAndEdits: 'Comments & Edits',
    addCommentPlaceholder: 'Add a comment about what you want to improve...',
    addCommentBtn: 'Add Comment',
    clear: 'Clear',
    resolved: 'Resolved',
    pending: 'Pending',
    markAsPending: 'Mark as pending',
    markAsResolved: 'Mark as resolved',
    editWithAI: 'Edit with AI',
    deleteComment: 'Delete comment',
    aiResponse: 'AI Response:',
    generatingHumorousResume: 'Generating Humorous Resume',
    status: 'Status:',
    jobId: 'Job ID:',
    close: 'Close',
    retry: 'Retry',
    downloadPdf: 'Download PDF',
    pipelineId: 'Pipeline ID:',
    started: 'Started:',
    completed: 'Completed:',
    funnyResumePreview: 'Funny Resume Preview',
    makeItFunny: 'Make it funny',
    makingItFunny: 'Making it funny...',
    transformingResumeStyle: 'Transforming Resume Style',
    aiPerformingSTAR: 'AI is performing STAR analysis...',
    starAnalysisSubtext: 'This may take 1-2 minutes as we analyze each work experience in detail',
    analyzingResumeStructure: 'Analyzing resume structure and experiences...',
    noSTARAnalysisYet: 'No STAR Analysis Yet',
    starAnalysisIntro: 'Get a detailed breakdown of your work experiences using the STAR method (Situation, Task, Action, Result).',
    performSTARAnalysis: 'Perform STAR Analysis',
    whatIsSTAR: 'What is STAR Analysis?',
    situation: 'Situation',
    situationDesc: 'The context or challenge you faced',
    task: 'Task',
    taskDesc: 'Your specific responsibility or goal',
    action: 'Action',
    actionDesc: 'The specific actions you took',
    result: 'Result',
    resultDesc: 'The measurable outcomes or results',
    starAnalysisHelps: 'This analysis helps identify clarity issues and improvement opportunities in your resume.',
    starAnalysisReport: 'STAR Analysis Report',
    copyAnalysis: 'Copy analysis',
    downloadAsPdf: 'Download as PDF',
    refreshAnalysis: 'Refresh analysis',
    analysisLanguage: 'Analysis Language:',
    downloadAnalysis: 'Download Analysis',
    synthesizeResume: 'Synthesize Resume',
    reanalyze: 'Re-analyze',
    insufficientCreditsService: 'Humorous Resume PDF Generation',
    useAsyncProcessingLongResumes: 'Use async processing (recommended for long resumes)',
    original: 'Original',
    transformed: 'Transformed',
    applyTransformation: 'Apply Transformation',
    tryDifferent: 'Try Different',
    regenerating: 'Regenerating...',
    humorousResumeTransformation: 'Humorous Resume Transformation'
  },
  acceptInvitation: {
    youreInvited: "You're Invited!",
    hasInvitedYou: 'has invited you to join AI4Resume',
    emailAddress: 'Email Address',
    emailFromInvitation: 'This email is from your invitation and cannot be changed.',
    username: 'Username',
    usernameHint: '3-30 characters, letters, numbers, and underscores only',
    firstName: 'First Name',
    lastName: 'Last Name',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    passwordRequirement: 'Must be at least 8 characters with uppercase, lowercase, number, and special character',
    creatingAccount: 'Creating Account...',
    createAccountAndJoin: 'Create Account & Join',
    invitationExpiresOn: 'This invitation expires on {date}',
    validatingInvitation: 'Validating invitation...',
    invalidInvitation: 'Invalid Invitation',
    goToHome: 'Go to Home'
  },
  verification: {
    emailVerificationRequired: 'Email Verification Required',
    emailVerifiedSuccess: 'Email Verified Successfully!',
    continueToApplication: 'Continue to Application',
    verificationFailed: 'Verification Failed',
    sendNewVerificationEmail: 'Send New Verification Email',
    verificationEmailQueued: 'Verification Email Queued',
    queuedMessage: 'Your verification email is in the waiting list and will be sent automatically when quota is available.',
    positionInQueue: 'Position in queue:',
    calculating: 'Calculating...',
    estimatedWait: 'Estimated wait:',
    queueNote: "You'll receive the email automatically when it's your turn. No action needed!",
    checking: 'Checking...',
    refreshStatus: 'Refresh Status',
    didntReceiveEmail: "Didn't receive the email? Check your spam folder or request a new verification email.",
    canRequestIn: 'You can request a new verification email in',
    sendVerificationEmail: 'Send Verification Email',
    sending: 'Sending...',
    checkingStatus: 'Checking verification status...',
    verificationSentTo: 'Verification email sent to:',
    checkInboxHint: 'Please check your inbox and click the verification link.',
    whatToDoNext: 'What to do next:',
    step1CheckEmail: 'Check your email inbox for a verification email',
    step2ClickLink: 'Click the verification link in the email',
    step3ReturnOrRefresh: 'Return to this page or refresh to continue',
    linkExpiresNote: 'Note: The verification link expires in 24 hours. If it expires, you can request a new one.',
    changeEmailAddress: 'Change Email Address',
    contactSupport: 'Contact Support',
    changeEmailTitle: 'Change Email Address',
    changeEmailIntro: 'Enter your new email address to receive the verification email.',
    newEmailAddress: 'New Email Address',
    newEmailPlaceholder: 'new@email.com',
    updating: 'Updating...',
    updateEmail: 'Update Email',
    enterVerificationCode: 'Enter Verification Code',
    codeSentTo: "We've sent a 6-digit verification code to ",
    codeExpiresIn: 'Code expires in:',
    resendCode: 'Resend Code',
    resendCodeIn: 'Resend code ({time})',
    sendingCode: 'Sending...',
    verifyingCode: 'Verifying code...',
    attemptsRemaining: 'attempts remaining'
  },
  notion: {
    connect: 'Connect Notion',
    disconnect: 'Disconnect',
    connected: 'Connected',
    disconnected: 'Not connected',
    connectedAs: 'Connected as {workspace}',
    connectNotion: 'Connect Notion',
    disconnectNotion: 'Disconnect Notion',
    privacyNote: 'Career Copilot will only access the titles and content of the pages you choose, to personalize advice.',
    errorDenied: 'Notion access was denied.',
    errorGeneric: 'Failed to connect to Notion. Please try again.',
    disconnectConfirm: 'Disconnect Notion? You can reconnect later.',
    settings: 'Settings',
    integrations: 'Integrations',
    exportToNotion: 'Export to Notion',
    exportSuccess: 'Conversation exported to Notion.',
    exportErrorNotConnected: 'Connect Notion in settings first to export.',
    exportErrorFailed: 'Export failed. Check the destination page and try again.',
    exportErrorForbidden: 'You do not have permission to export this conversation.',
    exportErrorNotFound: 'Conversation not found.',
    exportDestinationLabel: 'Notion page ID',
    exportDestinationPlaceholder: 'Paste the Notion page ID (from the page URL)',
    exportConsent: 'Export this conversation to Notion. Content will be written to the page you selected.',
    connectNotionFirst: 'Connect Notion first',
    exportModalTitle: 'Export to Notion',
    exporting: 'Exporting…',
    openInNotion: 'Open in Notion'
  },
  expandSearch: {
    alsoRecommending: 'Also recommending these related positions',
    expandedFromCity: 'Expanded search from {city}',
    noExactMatch: 'No exact matches found, showing related results'
  },
  errors: {
    passwordMinLength: 'Password must be at least 8 characters long',
    passwordMaxLength: 'Password must be less than 100 characters',
    passwordUppercase: 'Password must contain at least one uppercase letter',
    passwordLowercase: 'Password must contain at least one lowercase letter',
    passwordNumber: 'Password must contain at least one number',
    passwordSpecialChar: 'Password must contain at least one special character',
    passwordRequirementsCombined: 'Password must include uppercase, lowercase, number, and special character',
    passwordMismatch: 'Passwords do not match',
    passwordRequired: 'Password is required',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email format',
    emailExists: 'Email already exists',
    usernameRequired: 'Username is required',
    usernameMinLength: 'Username must be at least 3 characters long',
    usernameMaxLength: 'Username must be less than 30 characters',
    usernameInvalidChars: 'Username can only contain letters, numbers, underscores, and hyphens',
    usernameExists: 'Username already exists',
    invalidCredentials: 'Invalid email or password',
    rateLimited: 'Too many attempts, please try again later',
    weakPassword: 'Password does not meet security requirements',
    resetTokenMissing: 'Reset token is missing',
    resetFailed: 'Failed to reset password',
    invalidInvitationLink: 'Invalid invitation link',
    invalidOrExpiredInvitation: 'Invalid or expired invitation',
    failedToValidateInvitation: 'Failed to validate invitation',
    failedToCreateAccount: 'Failed to create account. Please try again.',
    firstNameRequired: 'First name is required',
    lastNameRequired: 'Last name is required',
    networkError: 'Network error: Unable to connect to server',
    serverError: 'The server is experiencing issues. Please try again later.',
    unknownError: 'An unexpected error occurred. Please try again.'
  }
}
